export class FeeFormClass {
    async getTemplate() {
        throw new Error("get template in fee form class needs to be overwritten");
    }

    async getAllowedTypes() {
        throw new Error("get allowed types in fee form class needs to be overwritten");
    }
}